const updates = [
  { title: '《斗破苍穹》第628话更新：萧炎突破斗尊', time: '10分钟前', tag: '热门' },
  { title: '《一人之下》第542话更新：宝儿姐身世揭晓', time: '25分钟前', tag: '热门' },
  { title: '《完美世界》第389话更新：石昊大战禁区之主', time: '1小时前', tag: '新更' },
  { title: '《狐妖小红娘》第416话更新：月红篇终章', time: '2小时前', tag: '新更' },
  { title: '《大王饶命》第315话更新：吕树遭遇新对手', time: '3小时前', tag: '新更' },
  { title: '《星骸骑士》第187话更新：机甲大战全面爆发', time: '4小时前', tag: '' },
  { title: '《镇魂街》第403话更新：曹焱兵集结守护灵', time: '5小时前', tag: '' },
  { title: '《全职高手》特别篇更新：叶修重返赛场', time: '6小时前', tag: '特别' },
  { title: '《镖人》第127话更新：刀马孤身闯敌营', time: '8小时前', tag: '' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          最新更新
        </h2>
        <p className="text-foreground-600 text-sm text-center mb-10 md:mb-14 max-w-xl mx-auto">
          实时追踪热门免费漫画的最新章节
        </p>
        <div className="max-w-[800px] mx-auto">
          {updates.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-center gap-4 py-4 px-4 rounded-lg hover:bg-background-50/70 transition-colors cursor-pointer group ${
                idx < updates.length - 1 ? 'border-b border-background-200/60' : ''
              }`}
            >
              <div className="w-2 h-2 rounded-full bg-primary-500 shrink-0 group-hover:scale-125 transition-transform"></div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
              </div>
              <div className="flex items-center gap-3 shrink-0">
                {item.tag && (
                  <span className={`px-2 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${
                    item.tag === '热门'
                      ? 'bg-accent-100 text-accent-700'
                      : item.tag === '特别'
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-secondary-100 text-secondary-700'
                  }`}>
                    {item.tag}
                  </span>
                )}
                <span className="text-xs text-foreground-400 whitespace-nowrap">
                  {item.time}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}